﻿import { initRegisterForm } from "./register";
import { getCountries } from "../../api/entities";
import { compareStrings } from "../../utils";
import {
  addDropdownOptions,
  getDropdownValue,
  setDropdownValue,
} from "../../components/dropdown";
import { closeModal, showModal } from "../../components/modal";
import { setValue } from "../../components/input";
import { updateAlertsState } from "./step4";
import { initUserGeoLocation } from "./step3_map";

const mapsSelectorModal = "#mapsSelectorModal";
const nonePostalCodeMessage = "#NonePostalCodeMessage";

let lat, lng, postalCode, countryCode, townName, province, radius;

$(() => {
  const step3Form = $("#registerStep3Form");

  initRegisterForm(step3Form);

  document
    .getElementById("PhoneNumber")
    .addEventListener("beforeinput", (event) => {
      const nextVal =
        event.target.value.substring(0, event.target.selectionStart) +
        (event.data ?? "") +
        event.target.value.substring(event.target.selectionEnd);
      if (!/(?<![A-Za-z0-9.])[0-9]+$/.test(nextVal)) {
        event.preventDefault();
      }
      return;
    });

  $("#PhonePrefix").on("change", (event) => {
    if ($("#PhoneNumber", event.target.form).val() != "")
      $(event.target.form).validate().element("#PhoneNumber");
  });

  getCountries(true, false)
    .done((countries) => {
      const dropdownInput = $("#PhonePrefix");
      const countriesList = [];
      let defaultCountry = null;

      countries
        .filter((country) => country.prefix)
        .sort((a, b) => compareStrings(a.description, b.description))
        .forEach((country) => {
          const option = {
            description: `${country.description} +${country.prefix}`,
            id: country.id,
          };
          countriesList.push(option);
        });

      if (window.location.pathname.includes("/es")) {
        defaultCountry = countriesList.find((country) => country.id === "011");
      }
      if (window.location.pathname.includes("/pt")) {
        defaultCountry = countriesList.find((country) => country.id === "010");
      }
      addDropdownOptions(dropdownInput, countriesList);
      if (!!!getDropdownValue(dropdownInput).value)
        setDropdownValue(
          dropdownInput,
          defaultCountry.description,
          defaultCountry.id
        );
    })
    .fail(() => {
      console.error("Error getCountries()");
    });

  document.addEventListener(
    "mapInfo",
    (mapInfo) => {
      lat = mapInfo.detail.lat;
      lng = mapInfo.detail.lng;
      postalCode = mapInfo.detail.postalCode;
      countryCode = mapInfo.detail.countryCode;
      townName = mapInfo.detail.townName;
      province = mapInfo.detail.province;
      radius = mapInfo.detail.radius;

      updateAlertsState(postalCode);

      setValue(
        document.getElementById("PostalCode"),
        `${mapInfo.detail.postalCode}, ${mapInfo.detail.townName}`
      );

      setValue(document.getElementById("Latitude"), lat);
      setValue(document.getElementById("Longitude"), lng);
      setValue(document.getElementById("Radius"), radius);
      setValue(document.getElementById("City"), townName);
      setValue(document.getElementById("Province"), province);

      $("#PostalCode").trigger("focusout");

      closeModal($(mapsSelectorModal));
    },
    false
  );

  $("#PostalCode").on("keydown", (event) => {
    event.preventDefault();
  });

  $("#PostalCode").on("click", (event) => {
    event.preventDefault();
  });

  $("#PostalCodeWrapper").on("click", (_) => {
    _showMapModal();
  });
});

function _showMapModal() {
  setTimeout(() => initUserGeoLocation(), 1000);

  event.preventDefault();
  lat = parseFloat(document.getElementById("Latitude")?.value);
  lng = parseFloat(document.getElementById("Longitude")?.value);
  radius = parseInt(document.getElementById("Radius")?.value);
  const townInfo = document.getElementById("PostalCode")?.value;
  if (townInfo) {
    postalCode = townInfo.split(", ")[0];
    townName = townInfo.split(", ")[1];
  }

  if (lat && lng && radius) {
    setTimeout(() => {
      const eventDetails = {
        lat,
        lng,
        postalCode,
        countryCode,
        townName,
        radius,
      };
      const setMapInfoEvent = new CustomEvent("setMapInfo", {
        detail: eventDetails,
      });
      document.dispatchEvent(setMapInfoEvent);
    }, 500);
  }
  showModal($(mapsSelectorModal), {
    showCloseButton: true,
    isFullScreen: true,
  });
}

export function updatePostalCodeMessage(showMessage) {
  showMessage
    ? $(nonePostalCodeMessage).removeClass("eui-d-none")
    : $(nonePostalCodeMessage).addClass("eui-d-none");
}